import { useContext } from 'react';
import { PaybackClientContext } from './PaybackClientProvider';

export const usePaybackClient = () => useContext(PaybackClientContext);
